import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, vShow as _vShow, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "filert-container" }
const _hoisted_3 = { class: "header-name" }
const _hoisted_4 = { class: "header-name" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "filert-container",
  style: {"margin-top":"20px"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _directive_waves = _resolveDirective("waves")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", _hoisted_3, _toDisplayString(_ctx.t('table.sourceServer')) + "：", 1),
      _createVNode(_component_el_input, {
        style: {"width":"200px"},
        modelValue: _ctx.listQuery.srcsvr,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.listQuery.srcsvr = $event))
      }, null, 8, ["modelValue"]),
      _createVNode("span", _hoisted_4, _toDisplayString(_ctx.t('table.targetServer')) + "：", 1),
      _createVNode(_component_el_input, {
        style: {"width":"200px"},
        modelValue: _ctx.listQuery.destsvr,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.listQuery.destsvr = $event))
      }, null, 8, ["modelValue"]),
      _withDirectives(_createVNode(_component_el_button, {
        class: "filter-item",
        type: "primary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toSearch())),
        icon: "el-icon-search"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("table.search")), 1)
        ]),
        _: 1
      }, 512), [
        [_directive_waves]
      ]),
      _withDirectives(_createVNode(_component_el_button, {
        class: "filter-item",
        icon: "el-icon-refresh",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toReset()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("table.reset")), 1)
        ]),
        _: 1
      }, 512), [
        [_directive_waves]
      ])
    ]),
    _hoisted_5,
    _withDirectives(_createVNode(_component_el_table, {
      data: _ctx.list,
      key: _ctx.tableKey,
      border: "",
      "highlight-current-row": "",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: _ctx.t('table.createTime')
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.createDate), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.t('table.sourceServer')
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.srcsvr), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.t('table.targetServer')
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.destsvr), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.t('table.operationType')
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.type === 1 ? _ctx.t('table.operationType') : _ctx.t('table.loadmigration')), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.t('table.operatorAdmin')
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.manager), 1)
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["data"]), [
      [_directive_loading, _ctx.listLoading]
    ]),
    _withDirectives(_createVNode(_component_el_pagination, {
      total: _ctx.total,
      currentPage: _ctx.listQuery.page.pageNo,
      "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => (_ctx.listQuery.page.pageNo = $event)),
      limit: _ctx.listQuery.page.pageSize,
      "onUpdate:limit": _cache[6] || (_cache[6] = ($event: any) => (_ctx.listQuery.page.pageSize = $event)),
      onSizeChange: _ctx.handleSizeChange,
      onCurrentChange: _ctx.handleCurrentChange,
      "page-sizes": [10, 20, 50, 100],
      layout: "total, sizes, prev, pager, next, jumper"
    }, null, 8, ["total", "currentPage", "limit", "onSizeChange", "onCurrentChange"]), [
      [_vShow, _ctx.total > 0]
    ])
  ]))
}